(function () {
  const setData = window.__mulataSetData;
  if (!setData) return;

  const { topHandle, bottomHandle } = setData;
  const colorOption = setData.colorOption || 'option1';
  const sizeOption = setData.sizeOption || 'option2';

  const swatchMap = {
    'Coconut Milk': 'https://www.mulata.pe/cdn/shop/files/off_white.jpg?v=1768587840&width=80',
    'Deep Blue': 'https://www.mulata.pe/cdn/shop/files/deep_blue_28fcee1d-5540-431c-8b49-d774bb859287.png?v=1762885632&width=80',
    'Bitter Chocolate': 'https://www.mulata.pe/cdn/shop/files/bitter_chocolate.jpg?v=1768927799&width=80',
    'Black': 'https://www.mulata.pe/cdn/shop/files/black.png?v=1762885621&width=80',
    'Burgundy': 'https://www.mulata.pe/cdn/shop/files/burgundy.jpg?v=1768922094&width=80',
    'Cocoa Brown': 'https://www.mulata.pe/cdn/shop/files/cocoa_brown.jpg?v=1771871170&width=80',
    'Summer Honey': 'https://www.mulata.pe/cdn/shop/files/summer_honey.jpg?v=1768589836&width=80',
    'Sky Blue': 'https://www.mulata.pe/cdn/shop/files/sky_blue.jpg?v=1768586144&width=80',
    'Khaki': 'https://www.mulata.pe/cdn/shop/files/khaki.jpg?v=1768930375&width=80',
    'Terracotta': 'https://www.mulata.pe/cdn/shop/files/terracota_9d96a4a6-7b50-4dd9-a04f-17a2541fbe98.jpg?v=1768928300&width=80',
    'Soft Pink': 'https://www.mulata.pe/cdn/shop/files/soft_pink.png?v=1762886634&width=80',
    'Passion Red': 'https://www.mulata.pe/cdn/shop/files/PASSION_RED.jpg?v=1768494473&width=80',
    'Coral Red': 'https://www.mulata.pe/cdn/shop/files/coral_red.png?v=1762886634&width=80',
    'Ruby Red': 'https://www.mulata.pe/cdn/shop/files/ruby_red.png?v=1762886634&width=80',
    'Deep Green': 'https://www.mulata.pe/cdn/shop/files/dark_green.png?v=1762885881&width=80',
    'Olive': 'https://www.mulata.pe/cdn/shop/files/olive.png?v=1762885824&width=80',
    'Pistachio': 'https://www.mulata.pe/cdn/shop/files/pistachio.png?v=1762886634&width=80',
    'Champagne': 'https://www.mulata.pe/cdn/shop/files/champagne.jpg?v=1768501212&width=80',
    'Salmon': 'https://www.mulata.pe/cdn/shop/files/salmon.jpg?v=1784941411&width=80',
    'Light Beige': 'https://www.mulata.pe/cdn/shop/files/light_beige.jpg?v=1768587674&width=80',
  };

  let topVariants = [];
  let bottomVariants = [];
  let selectedTopVariantId = null;
  let selectedBottomVariantId = null;
  let selectedColor = null;

  async function loadVariants() {
    try {
      const [topData, bottomData] = await Promise.all([
        fetch(`/products/${topHandle}.js`).then((r) => r.json()),
        fetch(`/products/${bottomHandle}.js`).then((r) => r.json()),
      ]);
      topVariants = topData.variants;
      bottomVariants = bottomData.variants;
      renderSelectors();
    } catch (err) {
      console.error('Mulata Sets: error cargando variantes', err);
    }
  }

  function getColors(variants) {
    return [...new Set(variants.map((v) => v[colorOption]))];
  }

  function getSizesForColor(variants, color) {
    return variants.filter((v) => v[colorOption] === color);
  }

  function getSwatchStyle(colorName) {
    const url = swatchMap[colorName];
    if (url) return `--swatch-background: url(${url}); --swatch-focal-point: 50.0% 50.0%;`;
    return '';
  }

  function renderSelectors() {
    const colors = getColors(topVariants);
    selectedColor = colors[0];

    const container = document.createElement('div');
    container.id = 'mulata-set-ui';
    container.innerHTML = `
      <div class="mulata-set-selectors">
        <div class="mulata-field">
          <label class="mulata-label">Color <span id="mulata-color-name">${selectedColor}</span></label>
          <div class="mulata-pills" id="mulata-colors">
            ${colors.map((c) => {
              const swatchStyle = getSwatchStyle(c);
              return `<button class="mulata-pill mulata-color-pill ${c === selectedColor ? 'selected' : ''}"
                        data-color="${c}" title="${c}">
                ${swatchStyle
                  ? `<span class="swatch swatch--unscaled" style="${swatchStyle}"></span>`
                  : c}
              </button>`;
            }).join('')}
          </div>
        </div>
        <div class="mulata-field">
          <label class="mulata-label">Talla Top</label>
          <div class="mulata-pills" id="mulata-top-sizes"></div>
        </div>
        <div class="mulata-field">
          <label class="mulata-label">Talla Bottom</label>
          <div class="mulata-pills" id="mulata-bottom-sizes"></div>
        </div>
        <button id="mulata-atc-btn" class="button add-to-cart-button button-secondary" disabled>
          Elige talla de top y bottom
        </button>
        <p id="mulata-error" style="color:red;display:none;margin-top:8px;"></p>
      </div>
    `;

    const buyButtons = document.querySelector('.buy-buttons-block');
    if (buyButtons) {
      buyButtons.style.display = 'none';
      buyButtons.parentNode.insertBefore(container, buyButtons);
    }

    const variantPicker = document.querySelector('variant-picker, .variant-picker');
    if (variantPicker) variantPicker.style.display = 'none';

    renderSizePills();
    attachEvents();
  }

  function renderSizePills() {
    const topSizes = getSizesForColor(topVariants, selectedColor);
    const bottomSizes = getSizesForColor(bottomVariants, selectedColor);

    document.getElementById('mulata-top-sizes').innerHTML = topSizes.map((v) => `
      <button class="mulata-pill ${!v.available ? 'unavailable' : ''}"
              data-variant-id="${v.id}" data-type="top"
              ${!v.available ? 'disabled' : ''}>
        ${v[sizeOption]}
      </button>
    `).join('');

    document.getElementById('mulata-bottom-sizes').innerHTML = bottomSizes.map((v) => `
      <button class="mulata-pill ${!v.available ? 'unavailable' : ''}"
              data-variant-id="${v.id}" data-type="bottom"
              ${!v.available ? 'disabled' : ''}>
        ${v[sizeOption]}
      </button>
    `).join('');

    selectedTopVariantId = null;
    selectedBottomVariantId = null;
    updateButton();
  }

  function attachEvents() {
    document.getElementById('mulata-colors').addEventListener('click', (e) => {
      const pill = e.target.closest('.mulata-color-pill');
      if (!pill) return;
      selectedColor = pill.dataset.color;
      document.querySelectorAll('.mulata-color-pill').forEach((p) => p.classList.remove('selected'));
      pill.classList.add('selected');
      const nameEl = document.getElementById('mulata-color-name');
      if (nameEl) nameEl.textContent = selectedColor;
      renderSizePills();
      attachSizeEvents();
    });

    attachSizeEvents();
    document.getElementById('mulata-atc-btn').addEventListener('click', addSetToCart);
  }

  function attachSizeEvents() {
    const topEl = document.getElementById('mulata-top-sizes');
    const bottomEl = document.getElementById('mulata-bottom-sizes');
    topEl.replaceWith(topEl.cloneNode(true));
    bottomEl.replaceWith(bottomEl.cloneNode(true));

    document.getElementById('mulata-top-sizes').addEventListener('click', (e) => {
      const pill = e.target.closest('.mulata-pill');
      if (!pill || pill.disabled) return;
      document.querySelectorAll('#mulata-top-sizes .mulata-pill').forEach((p) => p.classList.remove('selected'));
      pill.classList.add('selected');
      selectedTopVariantId = pill.dataset.variantId;
      updateButton();
    });

    document.getElementById('mulata-bottom-sizes').addEventListener('click', (e) => {
      const pill = e.target.closest('.mulata-pill');
      if (!pill || pill.disabled) return;
      document.querySelectorAll('#mulata-bottom-sizes .mulata-pill').forEach((p) => p.classList.remove('selected'));
      pill.classList.add('selected');
      selectedBottomVariantId = pill.dataset.variantId;
      updateButton();
    });
  }

  function updateButton() {
    const btn = document.getElementById('mulata-atc-btn');
    if (!btn) return;
    const ready = selectedTopVariantId && selectedBottomVariantId;
    btn.disabled = !ready;
    btn.textContent = ready ? 'Agregar set' : 'Elige talla de top y bottom';
  }

  async function addSetToCart() {
    const btn = document.getElementById('mulata-atc-btn');
    const error = document.getElementById('mulata-error');
    btn.disabled = true;
    btn.textContent = 'Agregando...';
    error.style.display = 'none';
    const setId = `set-${Date.now()}`;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(selectedTopVariantId), quantity: 1, properties: { _set_id: setId, _pieza: 'Top' } },
            { id: parseInt(selectedBottomVariantId), quantity: 1, properties: { _set_id: setId, _pieza: 'Bottom' } },
          ],
        }),
      });
      if (!res.ok) throw new Error('Error al agregar');
      window.location.href = '/cart';
    } catch (err) {
      error.textContent = 'Hubo un error al agregar el set. Intenta de nuevo.';
      error.style.display = 'block';
      btn.disabled = false;
      btn.textContent = 'Agregar set';
    }
  }

  loadVariants();
})();